import { createReducer, on } from '@ngrx/store';
import { displayFilePickerModal, hideFilePickerModal } from '../actions/shared.actions';

export const filePickerModalKey = 'filePickerModal';

export type filePickerModalState = {
  active: boolean;
  content?: string;
};
export const initialFilerPickerState: filePickerModalState = {
  active: false,
  content: '',
};

export const filePickerModalReducer = createReducer(
  initialFilerPickerState,
  on(displayFilePickerModal, (_state, { content }) => {
    return {
      active: true,
      content: content,
    };
  }),
  on(hideFilePickerModal, (state) => {
    return {
      ...state,
      active: false,
      content: '',
    };
  }),
);
